import { createSlice } from '@reduxjs/toolkit';
const getPlatformSlice = createSlice({
  name: 'getPlatformSlice',
  initialState: {
    data: null,   
    status:false,
  },
  reducers: {
    detectPlatform(state, action) {
      state.data = action.payload;
      state.status = true;           
    },
   


  },
});

export const { detectPlatform } = getPlatformSlice.actions;
export default getPlatformSlice.reducer;